<div class="d-flex align-items-center gap-3 mb-3">
	<span class="fw-semibold">Wynagrodzenie Gratyfikant</span>
	<button mat-raised-button color="primary" (click)="load()" [disabled]="isLoading()">
		@if (isLoading()) {
			<mat-spinner
				diameter="18"
				class="me-2 d-inline-block"
				style="--mdc-circular-progress-active-indicator-color: #fff"
			></mat-spinner>
		}
		Ściągnij dane
	</button>
</div>

@if (error()) {
	<div class="alert alert-danger d-flex align-items-center" role="alert">
		<i class="bi bi-exclamation-triangle-fill me-2"></i>
		<div><strong>Błąd:</strong> {{ error() }}</div>
	</div>
}

@if (loaded()) {
	@if (salaries().length === 0) {
		<p class="text-muted">Brak danych dla tego kierowcy w Gratyfikant.</p>
	} @else {
		<div class="table-responsive">
			<table mat-table [dataSource]="salaries()" class="w-100">
				@for (col of columns(); track col) {
					<ng-container [matColumnDef]="col">
						<th mat-header-cell *matHeaderCellDef>{{ col }}</th>
						<td mat-cell *matCellDef="let row">{{ row[col] }}</td>
					</ng-container>
				}
				<tr mat-header-row *matHeaderRowDef="columns()"></tr>
				<tr mat-row *matRowDef="let row; columns: columns()"></tr>
			</table>
		</div>
	}
}
